import { Slide } from '@features/powerpoint';
import { BuildPresentationProps } from './build-presentation';
import { executiveSummarySlide } from '../../../slides';
import { NEWLINE_REGEX } from '../../../domain/key-takeaways';

export const executiveSummarySlideFromProps = (
  props: BuildPresentationProps,
  slideMaster: string
): Slide[] => {
  if (!props.customFields.includedSlides.overall.executiveSummary) return [];

  return [
    executiveSummarySlide({
      slideMaster,
      rsaKeyTakeaways: props.customFields.rsaSummary.split(NEWLINE_REGEX),
      ftaKeyTakeaways: props.report.hasVisitMetrics
        ? props.customFields.ftaSummary.split(NEWLINE_REGEX)
        : [''],
    }),
  ];
};
